module.exports = __webpack_public_path__ + "media/images/shared/top-f37b0d71948715701e5c145847a5dd47.png";